module.exports = __webpack_public_path__ + "img/objCustomText.f53507a4.svg";